import { graphql } from "~/gql/gql";

export const QUICK_LINK_MATTER = graphql(/* GraphQL */ `
  mutation QuickLinkMatter($input: QuickLinkMatterInput!) {
    quickLinkMatter(input: $input) {
      id
      title
      status
      externalMatter {
        id
      }
      client {
        id
        name
      }
    }
  }
`);
